import React from "react";
import { UserDetails } from "./components/UserDetails.tsx";

export const userDetails = () => [
  {
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    handler: {
      component: UserDetails,
      props: { drawerName: "userDetailsDrawer" },
    },
  },
];
